import difference from 'lodash/difference';
import validUrl from 'valid-url';
import { ContextProps } from '../store/appContext';

export interface AlternateURL {
  href: string;
  hrefLang: string;
}

export interface CountryCode {
  id: string;
  isoCode: string;
}

const regexp = new RegExp('^/.*?(/|$)');

const englishHrefLang = (countryISO: string): string => {
  return `en-${countryISO}`;
};

const buildURL = (hostname: string, countryISO: string, noCountryPath: string): string => {
  if (noCountryPath.length === 0) {
    return `https://${hostname}/${countryISO}/`;
  }
  const filtered = [hostname, countryISO, noCountryPath];
  return `https://${filtered.join('/')}`;
};

const generateAlternateURLs = (
  countries: CountryCode[],
  location: ContextProps['location'],
  canonicalUrl: string,
  exclusions: string[],
  countryCode: string,
): AlternateURL[] => {
  let exclusionsCleaned = exclusions;
  if (!exclusionsCleaned) {
    exclusionsCleaned = [];
  }

  const { hostname } = location;
  const noCountryPath = canonicalUrl.replace(regexp, '');

  if (countries.every(country => country.isoCode !== countryCode)) {
    return [];
  }

  const finalCountries = difference(
    countries.map(el => el.isoCode.toLowerCase()),
    exclusionsCleaned.map(el => el.toLowerCase()),
  );

  return finalCountries
    .map(countryISO => {
      const href = buildURL(hostname, countryISO, noCountryPath);
      const hrefLang = englishHrefLang(countryISO);
      if (!validUrl.isUri(href)) {
        return null;
      }
      return { href, hrefLang };
    })
    .filter(el => el);
};

export { generateAlternateURLs };
